
import React, {useState} from 'react';
import { Pressable, View, Text } from "react-native";

import { useController } from "react-hook-form";


// Wrapper de esta librería
// https://github.com/lawnstarter/react-native-picker-select
import RNPickerSelect from 'react-native-picker-select';
import tw from '../../styles/tailwind';
import Icon from '../IcomoonIcon';



export default function Select(props){
  let field = null;
  let fieldState = null;

  if (props.control) {
    const controller = useController({
      control: props.control,
      defaultValue: props.value,
      name: props.name,
      rules: props.rules,
    });
    field = controller.field;
    fieldState = controller.fieldState;
  }


  const inputStyles = props.style ? props.style.input : {}
  const invalid = field ? fieldState?.invalid : false
  const error = field ? fieldState?.error : null
  const errorStyles = invalid ? { borderWidth:1, borderColor: tw.color('red')} : {}

  // Estilo unificado del selector (igual que los Input de texto: píldora gris).
  // El texto va más oscuro cuando hay un valor elegido, y gris claro como placeholder.
  const currentValue = field ? field.value : props.value
  const hasValue = currentValue !== undefined && currentValue !== null && currentValue !== ''
  const selectFieldStyle = tw.style(`bg-gray-100 rounded-lg px-6 h-12 font-bold`, {
    color: hasValue ? tw.color('gray-700') : tw.color('gray-400'),
    opacity: props.disabled ? 0.5 : 1,
    textAlignVertical: 'center',
  })


  function onValueChange(selectedValue, index){
    if(selectedValue == undefined) return
    
    const item = props.items.find(item => item.value == selectedValue)

    props.onChange && props.onChange(item?.value)

    // form
    field && field.onChange(item?.value)
  }

  const isInline = !!(props.inline && props.label)

  return <View style={[{}, props.style?.container]}>
    <View style={tw.style(`mb-5`, {flexDirection: 'row', alignItems: 'center'}, props.style?.wrapper)}>
      {
        isInline && <Text style={[{ fontWeight: '600', color: "#64707d"}, props.style?.label]}>{props.label}</Text>
      }

      <View style={{flex: 1}}>
        <RNPickerSelect
          placeholder={props.placeholder}
          onValueChange={onValueChange}
          items={props.items}
          value={field ? field.value : props.value}

          // Estilos
          useNativeAndroidPickerStyle={false}
          style={{
            viewContainer: {
              marginLeft: isInline ? 30 : 0,
            },

            inputWeb: [
              selectFieldStyle,
              { marginBottom: 0, appearance: 'none', width: '100%', borderWidth: 0 },
              props.style?.input,
              errorStyles,
            ],
            inputIOS: [
              selectFieldStyle,
              props.style?.input,
              errorStyles,
            ],
            inputAndroidContainer: {
              marginLeft: isInline ? 30 : 0,
            },
            inputAndroid: [
              selectFieldStyle,
              { marginBottom: 0 },
              props.style?.input,
              errorStyles,
            ],
            placeholder: { color: tw.color('gray-400') },
            iconContainer: {
              top: "50%",
              right: 15,
              marginTop: -4
            },
          }}

          disabled={props.disabled}

          // Icono
          Icon={() => {
            return (
              <Icon name='chevron-right' style={{ transform: [{ rotateZ: '90deg' }], marginRight: 5}} color={tw.color(props.iconColor ?? 'secondary')} />
            );
          }}
        />
      </View>

    </View>

    {
      !!error?.message && <Text style={{ marginTop: 10, color: tw.color('red-400') }}>{error.message}</Text>
    }
  </View>
}